// extracted by mini-css-extract-plugin
module.exports = {"pin":"_7a3fb80146--pin--CeCuA","slidein":"_7a3fb80146--slidein--mY70H","pin_main":"_7a3fb80146--pin_main--ZsWFT"};